export default "__VITE_ASSET__DayE_3cF__"